import { render, staticRenderFns } from "./KendoValueComponent.vue?vue&type=template&id=4bcd3dd1&"
import script from "./KendoValueComponent.vue?vue&type=script&lang=js&"
export * from "./KendoValueComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports